// React, Next
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

// Custom
import PillarSection, { PillarItem } from './PillarSection'
import { translateHref } from 'assets/functions/links'

// Config
import i18nextConfig from 'next-i18next.config'

// Img
import PillarImage from 'public/img/services/shop_floor2.webp'

// Style
import themeColors from 'assets/theme/colors'

export default function OtSecuritySection() {
  const { t } = useTranslation('index')

  const router = useRouter()
  const currentLocale = router.query.locale || i18nextConfig.i18n.defaultLocale

  const items: PillarItem[] = [
    {
      title: t('otSecurity.items.01.title'),
      paragraphs: [t('otSecurity.items.01.p1'), t('otSecurity.items.01.p2')],
      link: {
        label: t('otSecurity.items.01.link'),
        href: translateHref(currentLocale, 'ot-cybersecurity')
      }
    },
    {
      title: t('otSecurity.items.02.title'),
      paragraphs: [t('otSecurity.items.02.p1'), t('otSecurity.items.02.p2')]
    },
    {
      title: t('otSecurity.items.03.title'),
      paragraphs: [t('otSecurity.items.03.p1'), t('otSecurity.items.03.p2')],
      link: {
        label: t('otSecurity.items.03.link'),
        href: translateHref(currentLocale, 'ot-awareness-training')
      }
    }
  ]

  // *** MAIN RENDER ***
  return (
    <PillarSection
      eyebrow={t('otSecurity.eyebrow')}
      title={t('otSecurity.title')}
      paragraphs={[t('otSecurity.p1'), t('otSecurity.p2')]}
      image={PillarImage}
      imageSide="right"
      items={items}
      background={themeColors.section.light}
    />
  )
}
